// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__Link from "../../html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function LibrarySidebarPopular(Props) {
  let classNameOpt = Props.className;
  const className = classNameOpt !== undefined ? classNameOpt : "";
  const language = Buhta_landing__Route.getLanguage(undefined);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const pages = match[0].libraryFavorites;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("p", {
        children: "Избранное",
        className: "label text-gray-landing"
      }),
      Belt__Belt_List.toArray(Stdlib__List.map((function (page) {
        const Key = page.id;
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* LibraryArticle */ 6,
                  _0: page.slug
                }
              },
              className: "paragraph-medium text-black-landing mt-4 block",
              children: page.title
            }),
            JsxRuntime.jsx("hr", {
              className: "mt-4 text-divider"
            })
          ],
          className: "sidebar-popular-item"
        }, Key);
      }), pages))
    ],
    className: "rounded-sm bg-gray-pale px-6 py-4 " + className
  });
}

const make = LibrarySidebarPopular;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
